module.exports = __webpack_public_path__ + "img/InclusiveGateway.013a0ce2.svg";